// extracted by mini-css-extract-plugin
export var titleStyle = "previous_and_next_posts-module--titleStyle--zaBYP";